import { render, staticRenderFns } from "./NotificationAtStartup.vue?vue&type=template&id=14454183&scoped=true"
import script from "./NotificationAtStartup.vue?vue&type=script&lang=js"
export * from "./NotificationAtStartup.vue?vue&type=script&lang=js"
import style0 from "./NotificationAtStartup.vue?vue&type=style&index=0&id=14454183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14454183",
  null
  
)

export default component.exports